import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    metricsList: {
      // eslint-disable
      users_amount: {
        requestType: 'users_amount', time_interval_types: ['cur', 'prev'], taskName: 'Passengers number', customerType: ['airplane', 'airport'],
      },
      duration_on_map: {
        requestType: 'duration_on_map', time_interval_types: ['cur', 'prev'], taskName: 'Average time on map', customerType: ['airplane', 'airport'],
      },
      duration_on_map_advanced: {
        requestType: 'duration_on_map_advanced', time_interval_types: ['cur', 'prev'], taskName: 'Average time on map advanced', customerType: ['airplane', 'airport'],
      },
      average_sessions_per_passenger: {
        requestType: 'average_sessions_per_passenger', time_interval_types: ['cur'], taskName: 'Average sessions per passenger', customerType: ['airplane', 'airport'],
      },
      hashtag_rating: {
        requestType: 'hashtag_rating', time_interval_types: ['cur'], taskName: 'Hashtag rating', customerType: ['airplane', 'airport'],
      },
      hashtag_board: {
        requestType: 'hashtag_board', time_interval_types: ['cur'], taskName: 'Hashtag board', customerType: ['airplane', 'airport'],
      },
      hashtag_map: {
        requestType: 'hashtag_map', time_interval_types: ['cur'], taskName: 'Hashtag map', customerType: ['airplane', 'airport'],
      },
      hashtag_highlights: {
        requestType: 'hashtag_highlights', time_interval_types: ['cur'], taskName: 'Hashtag highlight', customerType: ['airplane'],
      },
      poi_destination_rating: {
        requestType: 'poi_destination_rating', time_interval_types: ['cur'], taskName: 'POIs destinations rating', customerType: ['airplane', 'airport'],
      },
      riddles_average: {
        requestType: 'riddles_average', time_interval_types: ['cur'], taskName: 'Riddles average duration', customerType: ['airplane', 'airport'],
      },
      destination_rating: {
        requestType: 'destination_rating', time_interval_types: ['cur'], taskName: 'Destinations rating', customerType: ['airplane', 'airport'],
      },
      poi_rating: {
        requestType: 'poi_rating', time_interval_types: ['cur'], taskName: 'POIs rating', customerType: ['airplane', 'airport'],
      },
      unique_users_date: {
        requestType: 'unique_users_date', time_interval_types: ['cur'], taskName: 'Unique users distribution', customerType: ['airplane', 'airport'],
      },
      feature_distribution: {
        requestType: 'feature_distribution', time_interval_types: ['cur'], taskName: 'Features views number', customerType: ['airplane', 'airport'],
      },
      feature_distribution_autoplay: {
        requestType: 'feature_distribution_autoplay', time_interval_types: ['cur'], taskName: 'Features views number (in autoplay)', customerType: ['airplane', 'airport'],
      },
      feature_distribution_not_autoplay: {
        requestType: 'feature_distribution_not_autoplay', time_interval_types: ['cur'], taskName: 'Features views number (out of autoplay)', customerType: ['airplane', 'airport'],
      },
      video_data: {
        requestType: 'video_data', time_interval_types: ['cur'], taskName: 'Videos number and duration', customerType: ['airplane', 'airport'],
      },
      images_data: {
        requestType: 'images_data', time_interval_types: ['cur'], taskName: 'Images number and duration', customerType: ['airplane', 'airport'],
      },
      riddles_data: {
        requestType: 'riddles_data', time_interval_types: ['cur'], taskName: 'Riddles number and duration', customerType: ['airplane', 'airport'],
      },
      get_langs: {
        requestType: 'get_langs', time_interval_types: ['cur'], taskName: 'Langs', customerType: ['airplane', 'airport'],
      },
      get_devices: {
        requestType: 'get_devices', time_interval_types: ['cur'], taskName: 'Devices', customerType: ['airplane', 'airport'],
      },
      get_os: {
        requestType: 'get_os', time_interval_types: ['cur'], taskName: 'Operating systems', customerType: ['airplane', 'airport'],
      },
      get_browsers: {
        requestType: 'get_browsers', time_interval_types: ['cur'], taskName: 'Browsers', customerType: ['airplane', 'airport'],
      },
      get_routes: {
        requestType: 'get_routes', time_interval_types: ['cur'], taskName: 'Routes', customerType: ['airplane', 'airport'],
      },
      get_filters: {
        requestType: 'get_filters', time_interval_types: ['cur'], taskName: 'Filters', customerType: ['airplane', 'airport'],
      },
      get_route_filters: {
        requestType: 'get_route_filters', time_interval_types: ['cur'], taskName: 'Routes with filters', customerType: ['airplane', 'airport'],
      },
      routes_amount: {
        requestType: 'routes_amount', time_interval_types: ['cur', 'prev'], taskName: 'Routes number', customerType: ['airplane', 'airport'],
      },
      poi_amount: {
        requestType: 'poi_amount', time_interval_types: ['cur', 'prev'], taskName: 'POIs views number', customerType: ['airplane', 'airport'],
      },
      poi_amount_highlights: {
        requestType: 'poi_amount_highlights', time_interval_types: ['cur', 'prev'], taskName: 'POIs views number', customerType: ['airplane'],
      },
      poi_amount_board: {
        requestType: 'poi_amount_board', time_interval_types: ['cur', 'prev'], taskName: 'POIs board views number', customerType: ['airplane', 'airport'],
      },
      poi_amount_map: {
        requestType: 'poi_amount_map', time_interval_types: ['cur', 'prev'], taskName: 'POIs map views number', customerType: ['airplane', 'airport'],
      },
      poi_amount_info: {
        requestType: 'poi_amount_info', time_interval_types: ['cur', 'prev'], taskName: 'POIs info views number', customerType: ['airplane', 'airport'],
      },
      unique_users_date_particular: {
        requestType: 'unique_users_date', time_interval_types: ['cur'], taskName: 'Unique users number particular', customerType: ['airplane', 'airport'],
      },
      get_tail_number_users: {
        requestType: 'get_tail_number_users', time_interval_types: ['cur'], taskName: 'Tail number unique users', customerType: ['airplane'],
      },
      get_flight_number_users: {
        requestType: 'get_flight_number_users', time_interval_types: ['cur'], taskName: 'Flight number unique users', customerType: ['airplane'],
      },
      get_flight_numbers_for_interval: {
        requestType: 'get_flight_numbers_for_interval', time_interval_types: ['cur'], taskName: 'Flight numbers number for a interval', customerType: ['airplane'],
      },
      get_tail_numbers_amount: {
        requestType: 'get_tail_numbers_amount', time_interval_types: ['cur'], taskName: 'Tail number number', customerType: ['airplane'],
      },
      get_flight_numbers_amount: {
        requestType: 'get_flight_numbers_amount', time_interval_types: ['cur'], taskName: 'Flight number number', customerType: ['airplane'],
      },
      get_flight_numbers_amount_date: {
        requestType: 'get_flight_numbers_amount_date', time_interval_types: ['cur'], taskName: 'Flight number date number', customerType: ['airplane'],
      },
      get_tail_numbers_amount_date: {
        requestType: 'get_tail_numbers_amount_date', time_interval_types: ['cur'], taskName: 'Tail number date number', customerType: ['airplane'],
      },
      tripbits_routemap: {
        requestType: 'tripbits_routemap', time_interval_types: ['cur'], taskName: 'Route map data', customerType: ['airport'],
      },
      route_destinations: {
        requestType: 'route_destinations', time_interval_types: ['cur'], taskName: 'Routes destinations', customerType: ['airplane'],
      },
      tails_numbers: {
        requestType: 'tails_numbers', time_interval_types: ['cur'], taskName: 'Tail numbers', customerType: ['airplane'],
      },
      poi_highlights: {
        requestType: 'poi_highlights', time_interval_types: ['cur'], taskName: 'Highlights', customerType: ['airplane'],
      },
      poi_pins: {
        requestType: 'poi_pins', time_interval_types: ['cur'], taskName: 'Map pins', customerType: ['airplane', 'airport'],
      },
      poi_board: {
        requestType: 'poi_board', time_interval_types: ['cur'], taskName: 'Board', customerType: ['airplane', 'airport'],
      },
      microsite_highlights: {
        requestType: 'microsite_highlights', time_interval_types: ['cur'], taskName: 'Microsite highlights', customerType: ['airplane'],
      },
      microsite_board: {
        requestType: 'microsite_board', time_interval_types: ['cur'], taskName: 'Microsite board', customerType: ['airplane', 'airport'],
      },
      microsite_show: {
        requestType: 'microsite_show', time_interval_types: ['cur'], taskName: 'Microsite show', customerType: ['airplane', 'airport'],
      },
      playlist_highlights: {
        requestType: 'playlist_highlights', time_interval_types: ['cur'], taskName: 'Playlists (hashtags) highlights', customerType: ['airplane'],
      },
      playlist_board: {
        requestType: 'playlist_board', time_interval_types: ['cur'], taskName: 'Playlists (hashtags) board click', customerType: ['airplane', 'airport'],
      },
      playlists_board: {
        requestType: 'playlists_board', time_interval_types: ['cur'], taskName: 'Playlists (hashtags) board show', customerType: ['airplane', 'airport'],
      },
      advertisement: {
        requestType: 'advertisement', time_interval_types: ['cur'], taskName: 'Advertisement show', customerType: ['airplane', 'airport'],
      },
      poi_info_page: {
        requestType: 'poi_info_page', time_interval_types: ['cur'], taskName: 'POI info page', customerType: ['airplane', 'airport'],
      },
      // eslint-enable
    },

    devicesTypesMapping: {
      mobile: ['Mobile Phone', 'Mobile Device', 'Ebook Reader'],
      tablet: ['Tablet'],
      desktop: ['Desktop', 'n/a', 'unknown'],
    },

    activePagedItemNumber: {
      route: 0,
      destination: 0,
      filter: 0,
    },

    metricsData: {},

    staticMetricsData: {},

    routeDestinations: [],

    airportAppUrl: '',

    isCompositeCustomerHasAirport: false,

    isUseStaticMetricData: false,

    airplaneAlwaysMainDatasetSlugs: [
      'passenger_number',
      'passengers_three_months',
      'language_chart_short',
      'average_sessions_per_passenger',
      'mobile_number_type_one',
      'tablet_number_type_one',
      'laptop_number_type_one',
      'active_passengers_chart',
      'language_paged_list',
      'mobile_number_type_two',
      'tablet_number_type_two',
      'laptop_number_type_two',
      'device_accordion',
      'operating_system_accordion',
      'browser_accordion',
    ],
  },

  getters: {
    // TODO: move to other storage
    airportAppUrl: (state) => state.airportAppUrl,

    isCompositeCustomerHasAirport: (state) => state.isCompositeCustomerHasAirport,

    metricsData: (state) => state.metricsData,

    metricsList: (state) => state.metricsList,

    isGlobalPercent: (state, getters, rootState) => rootState.controls.isGlobalPercent,

    activeDestinationNumber: (state) => state.activePagedItemNumber.destination,

    activeRouteNumber: (state) => state.activePagedItemNumber.route,

    activeFilterNumber: (state) => state.activePagedItemNumber.filter,

    metricDataMapping: (state, getters) => ({
      // static
      passenger_number: getters.infoDataPassengers,
      duration_on_map: getters.infoDataAvgTimeMap,
      duration_on_map_advanced: getters.infoDataAvgTimeMapAdvanced,
      places_viewed: getters.infoDataPoiAmount,
      places_viewed_native: getters.infoDataPoiAmount,
      routes_viewed: getters.infoDataRoutesAmount,

      // overview airplane
      passengers_three_months: getters.dataUsers,
      popular_destinations_short: getters.ratingsDataPopularDestinationsShort,
      popular_destinations_short_native: getters.ratingsDataPopularDestinationsShort,
      popular_places_short: getters.ratingsDataPopularPoiShort,
      popular_places_short_native: getters.ratingsDataPopularPoiShort,
      interests_chart_short: getters.interestsShort,
      interests_chart_short_native: getters.interestsShort,
      language_chart_short: getters.dataLanguages,
      average_sessions_per_passenger: getters.infoDataAverageSessionsPerPassenger,
      mobile_number_type_one: getters.deviceNumberMobile,
      tablet_number_type_one: getters.deviceNumberTablet,
      laptop_number_type_one: getters.deviceNumberDesktop,

      // overview airport
      rm_airport_number: getters.airportRouteMapDataNumberOfAirports,
      rm_flights_per_month: getters.airportRouteMapDataFlightsPerMonth,
      ap_popular_destinations_short: getters.ratingsDataAirportPopularDestinationOverview,
      ap_popular_routes_short: getters.ratingsDataAirportPopularRoutesOverview,
      ap_popular_interests_short: getters.ratingsDataAirportPopularInterestsOverview,
      ap_tb_guides_number: getters.airportTripbitsDataNumberOfGuides,
      ap_tb_pois_number: getters.airportTripbitsDataNumberOfPoi,
      ap_tb_reels_number: getters.airportTripbitsDataNumberOfReels,

      // engagement
      active_passengers_chart: getters.usersByDate,
      feature_usage_chart: getters.featuresUsage,
      feature_autoplay_usage_chart: getters.featuresUsageAutoplay,
      feature_not_autoplay_usage_chart: getters.featuresUsageNotAutoplay,
      video_number_chart: getters.videoAmount,
      video_duration_chart: getters.videoDuration,
      images_number_chart: getters.imagesAmount,
      images_duration_chart: getters.imagesDuration,
      riddles_number_chart: getters.riddlesAmount,
      riddles_duration_chart: getters.riddlesDuration,

      // destinations
      popular_destinations_paged_list: getters.ratingsProgressDataDestinations,
      popular_destinations_paged_list_native: getters.ratingsProgressDataDestinations,
      popular_places_paged_list: getters.ratingsProgressDataPois,
      popular_places_paged_list_native: getters.ratingsProgressDataPois,
      popular_places_paged_list_no_highlights: getters.ratingsProgressDataPois,
      destination_relations_tabs: getters.unitedDestinationData,
      destination_relations_tabs_no_highlights: getters.unitedDestinationData,
      riddles_average_paged_list: getters.ratingsDataRiddlesAverage,

      // new tab
      microsites_paged_list: getters.ratingsDataMicrositesFull,
      microsites_paged_list_no_highlights: getters.ratingsDataMicrositesFull,
      playlists_paged_list_no_highlights: getters.ratingsDataPlaylistsFull,
      playlists_paged_list: getters.ratingsDataPlaylistsFull,
      advertisement_paged_list: getters.ratingsDataAdvertisement,

      // routes
      routes_paged_list: getters.ratingsProgressDataRouteParams,
      filters_paged_list: getters.ratingsProgressDataFilters,
      filter_values_paged_list: getters.ratingsProgressDataSelections,

      // passengers
      interests_paged_list: getters.ratingsProgressDataPassengersInterests,
      interests_paged_list_native: getters.ratingsProgressDataPassengersInterests,
      language_paged_list: getters.ratingsProgressDataPassengersLanguages,

      // devices
      mobile_number_type_two: getters.deviceNumberMobile,
      tablet_number_type_two: getters.deviceNumberTablet,
      laptop_number_type_two: getters.deviceNumberDesktop,
      device_accordion: getters.ratingsProgressDataUserDevices,
      operating_system_accordion: getters.ratingsProgressDataUserOperatingSystems,
      browser_accordion: getters.ratingsProgressDataUserBrowsers,

      // tail numbers
      tail_numbers_paged_list: getters.ratingsProgressDataTailNumberUsers,
      tail_numbers_number: getters.infoDataTailNumbersAmount,
      tail_numbers_chart: getters.tailNumbers,

      // flight numbers
      flight_numbers_paged_list: getters.ratingsProgressDataFlightNumberUsers,
      flight_numbers_and_users_paged_list: getters.ratingsDataFlightNumbersAndUsersForInterval,
      flight_numbers_number: getters.infoDataFlightNumbersAmount,
      flight_numbers_chart: getters.flightNumbers,
    }),

    metricDataBySlug: (state, getters) => (slug) => {
      if (state.isUseStaticMetricData) {
        return state.staticMetricsData[slug];
      }

      return getters.metricDataMapping[slug];
    },

    routeDestinations: (state) => state.routeDestinations,

    getMetricDataValueByKey: (state) => ({ metricKey, metricsArray = null }) => {
      // eslint-disable-next-line no-param-reassign
      metricsArray = metricsArray === null ? state.metricsData : metricsArray;

      if (metricsArray[metricKey] === undefined || metricsArray[metricKey] == null) {
        return 0;
      }

      if (metricsArray[metricKey].data == null) {
        return 0;
      }

      return metricsArray[metricKey].data[0].value;
    },

    getMetricSpecificDataValueByKey: (state) => ({ metricKey, dataKey, metricsArray = null }) => {
      // eslint-disable-next-line no-param-reassign
      metricsArray = metricsArray === null ? state.metricsData : metricsArray;

      if (metricsArray[metricKey] === undefined || metricsArray[metricKey] == null) {
        return 0;
      }

      if (metricsArray[metricKey].data == null || metricsArray[metricKey].data.length === 0) {
        return 0;
      }

      return metricsArray[metricKey].data[dataKey];
    },

    getMetricDataArrayByKey: (state) => ({ metricKey, metricsArray = null }) => {
      // eslint-disable-next-line no-param-reassign
      metricsArray = metricsArray === null ? state.metricsData : metricsArray;

      if (metricsArray[metricKey] === undefined || metricsArray[metricKey] == null) {
        return [];
      }

      if (metricsArray[metricKey].data == null) {
        return [];
      }

      return [...metricsArray[metricKey].data];
    },

    getMetricDataObjectByKey: (state) => ({ metricKey, metricsArray = null }) => {
      // eslint-disable-next-line no-param-reassign
      metricsArray = metricsArray === null ? state.metricsData : metricsArray;

      if (metricsArray[metricKey] === undefined || metricsArray[metricKey] == null) {
        return {};
      }

      if (metricsArray[metricKey].data == null) {
        return {};
      }

      return metricsArray[metricKey].data;
    },

    getValueChangeInPercent: () => ({ value1, value2 }) => {
      let colorStyle = 'neutral';
      let signMark = '';
      let diffVal = 0;

      if (value1 !== null && value2 != null) {
        const diff = 100 * (value1 - value2);

        if (diff < 0) {
          colorStyle = 'negative';
        } else if (diff > 0) {
          colorStyle = 'positive';
          signMark = '+';
        }

        diffVal = value2 === 0
          ? `${(diff).toFixed(1)}%`
          : `${(diff / value2).toFixed(1)}%`;
      }

      return {
        value: `${signMark}${diffVal}`,
        style: colorStyle,
      };
    },

    // ---------------------------------------------------
    // METRICS START
    // ---------------------------------------------------

    infoDataPassengers: (state, getters) => {
      const value1 = getters.getMetricDataValueByKey({ metricKey: 'users_amount_cur' });
      const value2 = getters.getMetricDataValueByKey({ metricKey: 'users_amount_prev' });

      const changes = getters.getValueChangeInPercent({ value2, value1 });

      const bounced = getters.getMetricDataValueByKey({ metricKey: 'users_amount_cur' })
      - getters.getMetricDataValueByKey({ metricKey: 'users_amount_cur' });

      return {
        value1,
        value2,
        changes,
        bounced,
      };
    },

    infoDataAvgTimeMap: (state, getters) => {
      const value1 = getters.getMetricDataValueByKey({ metricKey: 'duration_on_map_cur' });
      const value2 = getters.getMetricDataValueByKey({ metricKey: 'duration_on_map_prev' });
      const changes = getters.getValueChangeInPercent({ value2, value1 });

      return {
        value1,
        value2,
        changes,
      };
    },

    infoDataAvgTimeMapAdvanced: (state, getters) => {
      const value1 = getters.getMetricDataValueByKey({ metricKey: 'duration_on_map_advanced_cur' });
      const value2 = getters.getMetricDataValueByKey({ metricKey: 'duration_on_map_advanced_prev' });
      const changes = getters.getValueChangeInPercent({ value2, value1 });

      return {
        value1,
        value2,
        changes,
      };
    },

    infoDataAverageSessionsPerPassenger: (state, getters) => getters.getMetricDataValueByKey({
      metricKey: 'average_sessions_per_passenger_cur',
    }),

    infoDataRoutesAmount: (state, getters) => {
      const value1 = getters.getMetricDataValueByKey({ metricKey: 'routes_amount_cur' });
      const value2 = getters.getMetricDataValueByKey({ metricKey: 'routes_amount_prev' });
      const changes = getters.getValueChangeInPercent({ value2, value1 });

      return {
        value1,
        value2,
        changes,
      };
    },

    poiNumberFull: (state, getters) => (period = 'cur') => {
      const clickValue = getters.getMetricDataValueByKey({ metricKey: `poi_amount_${period}` });
      const mapValue = getters.getMetricDataValueByKey({ metricKey: `poi_amount_map_${period}` });
      const boardValue = getters.getMetricDataValueByKey({ metricKey: `poi_amount_board_${period}` });
      const highlightsValue = getters.getMetricDataValueByKey({ metricKey: `poi_amount_highlights_${period}` });
      const infoValue = getters.getMetricDataValueByKey({ metricKey: `poi_amount_info_${period}` });

      // eslint-disable-next-line max-len
      return [clickValue, infoValue, mapValue, boardValue, highlightsValue].reduce((accum, cur) => accum + cur, 0);
    },

    infoDataPoiAmount: (state, getters) => {
      const value1 = getters.poiNumberFull('cur');
      const value2 = getters.poiNumberFull('prev');
      const changes = getters.getValueChangeInPercent({ value2, value1 });

      return {
        value1,
        value2,
        changes,
      };
    },

    // overview
    ratingsDataPopularDestinationsShort: (state, getters) => Vue.$arrayManagement
      .normalizedDataArray(
        getters.ratingsProgressDataDestinations.map(
          (el) => ({
            label: el.label,
            value: el.value,
          }),
        ).filter((el) => el.label !== '<All>'),
      ).slice(0, 3),

    ratingsDataPoiFull: (state, getters) => {
      const poiDestinations = getters.getMetricDataArrayByKey({ metricKey: 'poi_destination_rating_cur' });
      const poiHighlights = getters.getMetricDataArrayByKey({ metricKey: 'poi_highlights_cur' });
      const poiBoard = getters.getMetricDataArrayByKey({ metricKey: 'poi_board_cur' });
      const poiPins = getters.getMetricDataArrayByKey({ metricKey: 'poi_pins_cur' });
      const poiInfo = getters.getMetricDataArrayByKey({ metricKey: 'poi_info_page_cur' });

      const valuesArray = [
        { arrayItem: poiDestinations, label: 'click' },
        { arrayItem: poiHighlights, label: 'highlights' },
        { arrayItem: poiBoard, label: 'board' },
        { arrayItem: poiPins, label: 'pins' },
        { arrayItem: poiInfo, label: 'view_info' },
      ];

      const fullPois = [];

      valuesArray.forEach((valElement) => {
        valElement.arrayItem.forEach((el) => {
          if (fullPois[el.id] === undefined) {
            fullPois[el.id] = {
              name: el.name,
              id: el.id,
              geotags: el.geotags,
              value: 0,
              values: {
                total: 0,
                click: 0,
                highlights: 0,
                pins: 0,
                board: 0,
                view_info: 0,
              },
              links: {
                videos: el.videos,
              },
            };
          }

          fullPois[el.id].values[valElement.label] += el.value;
          fullPois[el.id].values.total += el.value;
          fullPois[el.id].value += el.value;
        });
      });

      return Object.values(fullPois).sort((a, b) => b.value - a.value);
    },

    ratingsDataPopularPoiShort: (state, getters) => {
      const poisByName = {};

      getters.ratingsDataPoiFull.forEach((el) => {
        if (poisByName[el.name] === undefined) {
          poisByName[el.name] = { label: el.name, value: 0 };
        }

        poisByName[el.name].value += el.value;
      });

      const mergedPois = Object.values(poisByName).sort((a, b) => b.value - a.value);

      return Vue.$arrayManagement.normalizedDataArray(mergedPois.slice(0, 3));
    },

    // eslint-disable-next-line max-len
    ratingsDataAirportPopularDestinationOverview: (state, getters) => Vue.$arrayManagement
      .normalizedDataArray(
        getters.ratingsProgressDataDestinations.map(
          (el) => ({
            label: el.label,
            value: el.value,
          }),
        ).filter((el) => el.label !== '<All>'),
      ).slice(0, 5),

    ratingsDataAirportPopularRoutesOverview: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_routes_cur' });

      return Vue.$arrayManagement.normalizedDataArray(metric).slice(0, 5);
    },

    ratingsDataMicrositesFull: (state, getters) => {
      const micrositesShow = getters.getMetricDataArrayByKey({ metricKey: 'microsite_show_cur' });
      const micrositesHighlights = getters.getMetricDataArrayByKey({ metricKey: 'microsite_highlights_cur' });
      const micrositesBoard = getters.getMetricDataArrayByKey({ metricKey: 'microsite_board_cur' });

      const valuesArray = [
        { arrayItem: micrositesShow, label: 'show' },
        { arrayItem: micrositesHighlights, label: 'highlights' },
        { arrayItem: micrositesBoard, label: 'board' },
      ];

      const fullMicrosites = [];

      valuesArray.forEach((valElement) => {
        valElement.arrayItem.forEach((el) => {
          if (fullMicrosites[el.id] === undefined) {
            fullMicrosites[el.id] = {
              label: el.label,
              id: el.id,
              value: 0,
              geotags: [{ label: '<All>', id: 0 }],
              values: {
                total: 0,
                show: 0,
                highlights: 0,
                board: 0,
              },
            };
          }

          fullMicrosites[el.id].values[valElement.label] += el.value;
          fullMicrosites[el.id].values.total += el.value;
          fullMicrosites[el.id].value += el.value;
        });
      });

      fullMicrosites.sort((a, b) => b.value - a.value);

      fullMicrosites.unshift({
        label: '<All>',
        id: 0,
        value: fullMicrosites.reduce((prev, cur) => prev + cur.value, 0),
        geotags: [{ label: '<All>', id: 0 }],
        values: {
          total: fullMicrosites.reduce((prev, cur) => prev + cur.values.total, 0),
          show: fullMicrosites.reduce((prev, cur) => prev + cur.values.show, 0),
          highlights: fullMicrosites.reduce((prev, cur) => prev + cur.values.highlights, 0),
          board: fullMicrosites.reduce((prev, cur) => prev + cur.values.board, 0),
        },
      });

      return fullMicrosites;
    },

    ratingsDataMicrositesFullDestinations: (state, getters) => {
      const { ratingsProgressDataDestinations } = getters;
      const ratingsDataMicrositesFull = getters.ratingsDataMicrositesFull
        .filter((el) => el.label !== '<All>');

      const metric = [];

      ratingsProgressDataDestinations.forEach((destinationItem) => {
        const micrositeItem = {
          label: destinationItem.label,
          id: destinationItem.id,
        };

        micrositeItem.microsites = ratingsDataMicrositesFull
          .filter((el) => el.geotags.some((gel) => destinationItem.ids.includes(gel.id)));

        micrositeItem.microsites.unshift({
          label: '<All>',
          id: 0,
          value: micrositeItem.microsites.reduce((accum, cur) => accum + cur.value, 0),
          values: {
            total: micrositeItem.microsites.reduce((prev, cur) => prev + cur.values.total, 0),
            show: micrositeItem.microsites.reduce((prev, cur) => prev + cur.values.show, 0),
            // eslint-disable-next-line max-len
            highlights: micrositeItem.microsites.reduce((prev, cur) => prev + cur.values.highlights, 0),
            board: micrositeItem.microsites.reduce((prev, cur) => prev + cur.values.board, 0),
          },
        });

        metric.push(micrositeItem);
      });

      return metric;
    },

    ratingsDataPlaylistsFull: (state, getters) => {
      const playlistsBoardClick = getters.getMetricDataArrayByKey({ metricKey: 'playlist_board_cur' });
      const playlistsBoardShow = getters.getMetricDataArrayByKey({ metricKey: 'playlists_board_cur' });
      const playlistsHighlights = getters.getMetricDataArrayByKey({ metricKey: 'playlist_highlights_cur' });

      const valuesArray = [
        { arrayItem: playlistsBoardShow, label: 'board_show' },
        { arrayItem: playlistsBoardClick, label: 'board_click' },
        { arrayItem: playlistsHighlights, label: 'highlights' },
      ];

      const fullPlaylists = [];

      valuesArray.forEach((valElement) => {
        valElement.arrayItem.forEach((el) => {
          if (fullPlaylists[el.id] === undefined) {
            fullPlaylists[el.id] = {
              label: el.label,
              id: el.id,
              value: 0,
              geotags: [{ label: '<All>', id: 0 }, ...el.geotags.map((elGeotag) => ({ label: elGeotag.label, id: elGeotag.id }))],
              values: {
                total: 0,
                board_show: 0,
                board_click: 0,
                highlights: 0,
              },
            };
          }

          fullPlaylists[el.id].values[valElement.label] += el.value;
          fullPlaylists[el.id].values.total += el.value;
          fullPlaylists[el.id].value += el.value;
        });
      });

      fullPlaylists.sort((a, b) => b.value - a.value);

      fullPlaylists.unshift({
        label: '<All>',
        id: 0,
        value: fullPlaylists.reduce((prev, cur) => prev + cur.value, 0),
        geotags: [{ label: '<All>', id: 0 }],
        values: {
          total: fullPlaylists.reduce((prev, cur) => prev + cur.values.total, 0),
          board_show: fullPlaylists.reduce((prev, cur) => prev + cur.values.board_show, 0),
          board_click: fullPlaylists.reduce((prev, cur) => prev + cur.values.board_click, 0),
          highlights: fullPlaylists.reduce((prev, cur) => prev + cur.values.highlights, 0),
        },
      });

      return fullPlaylists;
    },

    ratingsDataPlaylistsFullDestinations: (state, getters) => {
      const { ratingsProgressDataDestinations } = getters;
      const ratingsDataPlaylistsFull = getters.ratingsDataPlaylistsFull
        .filter((el) => el.label !== '<All>');

      const metric = [];

      ratingsProgressDataDestinations.forEach((destinationItem) => {
        const playlistItem = {
          label: destinationItem.label,
          id: destinationItem.id,
        };

        playlistItem.playlists = ratingsDataPlaylistsFull
          .filter((el) => el.geotags.some((gel) => destinationItem.ids.includes(gel.id)));

        playlistItem.playlists.unshift({
          label: '<All>',
          id: 0,
          value: playlistItem.playlists.reduce((accum, cur) => accum + cur.value, 0),
          values: {
            total: playlistItem.playlists.reduce((prev, cur) => prev + cur.values.total, 0),
            // eslint-disable-next-line max-len
            board_show: playlistItem.playlists.reduce((prev, cur) => prev + cur.values.board_show, 0),
            // eslint-disable-next-line max-len
            board_click: playlistItem.playlists.reduce((prev, cur) => prev + cur.values.board_click, 0),
            // eslint-disable-next-line max-len
            highlights: playlistItem.playlists.reduce((prev, cur) => prev + cur.values.highlights, 0),
          },
        });

        metric.push(playlistItem);
      });

      return metric;
    },

    ratingsDataAdvertisement: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'advertisement_cur' });

      const metricWithGeotags = metric.map((el) => ({ ...el, geotags: [{ label: '<All>', id: 0 }] }));
      metricWithGeotags.sort((a, b) => b.value - a.value);

      metricWithGeotags.unshift({
        label: '<All>',
        id: 0,
        geotags: [{ label: '<All>', id: 0 }],
        value: metricWithGeotags.reduce((prev, cur) => prev + cur.value, 0),
      });

      return metricWithGeotags;
    },

    ratingsDataAdvertisementDestinations: (state, getters) => {
      const { ratingsProgressDataDestinations } = getters;
      const ratingsDataAdvertisement = getters.ratingsDataAdvertisement
        .filter((el) => el.label !== '<All>');

      const metric = [];

      ratingsProgressDataDestinations.forEach((destinationItem) => {
        const advertisementItem = {
          label: destinationItem.label,
          id: destinationItem.id,
        };

        advertisementItem.advertisements = ratingsDataAdvertisement
          .filter((el) => el.geotags.some((gel) => destinationItem.ids.includes(gel.id)));

        advertisementItem.advertisements.unshift({
          label: '<All>',
          id: 0,
          value: advertisementItem.advertisements.reduce((accum, cur) => accum + cur.value, 0),
        });

        metric.push(advertisementItem);
      });

      return metric;
    },

    interests: (state, getters) => {
      const interestsClick = getters.getMetricDataArrayByKey({ metricKey: 'hashtag_rating_cur' });
      const interestsMap = getters.getMetricDataArrayByKey({ metricKey: 'hashtag_map_cur' });
      const interestsBoard = getters.getMetricDataArrayByKey({ metricKey: 'hashtag_board_cur' });
      const interestsHighlights = getters.getMetricDataArrayByKey({ metricKey: 'hashtag_highlights_cur' });

      const interests = {};

      // eslint-disable-next-line max-len
      [...interestsClick, ...interestsMap, ...interestsBoard, ...interestsHighlights].forEach((el) => {
        if (interests[el.label] === undefined) {
          interests[el.label] = { label: el.label, value: 0 };
        }

        interests[el.label].value += el.value;
      });

      const interestsArray = Object.values(interests);

      interestsArray.sort((a, b) => b.value - a.value);

      return interestsArray;
    },

    ratingsDataAirportPopularInterestsOverview: (state, getters) => {
      const metric = getters.interests;

      return Vue.$arrayManagement.normalizedDataArray(metric).slice(0, 5);
    },

    interestsShort: (state, getters) => {
      const metric = getters.interests;

      return metric.slice(0, 3);
    },

    dataLanguages: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_langs_cur' });

      return metric.slice(0, 3);
    },

    dataUsers: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'unique_users_date_particular_cur' }),

    ratingsProgressDataTailNumberUsers: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_tail_number_users_cur' });

      return Vue.$arrayManagement.normalizedDataArray(metric);
    },

    ratingsProgressDataFlightNumberUsers: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_flight_number_users_cur' });

      return Vue.$arrayManagement.normalizedDataArray(metric);
    },

    ratingsProgressDataFlightNumberForInterval: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_flight_numbers_for_interval_cur' });

      return Vue.$arrayManagement.normalizedDataArray(metric);
    },

    ratingsDataFlightNumbersAndUsersForInterval: (state, getters) => {
      const users = getters.ratingsProgressDataFlightNumberUsers;
      const flights = getters.ratingsProgressDataFlightNumberForInterval;

      const metric = [];

      users.forEach((el) => {
        const userFlights = flights.find((fl) => fl.label === el.label);
        metric[el.label] = {
          label: el.label,
          values: {
            flights: userFlights !== undefined ? userFlights.value : 0,
            passengers: el.value,
          },
        };
      });

      const metricArray = Object.values(metric);
      metricArray.sort((a, b) => b.values.passengers - a.values.passengers);

      return metricArray;
    },

    infoDataTailNumbersAmount: (state, getters) => getters.getMetricDataValueByKey({ metricKey: 'get_tail_numbers_amount_cur' }),

    infoDataFlightNumbersAmount: (state, getters) => getters.getMetricDataValueByKey({ metricKey: 'get_flight_numbers_amount_cur' }),

    tailNumbers: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'get_tail_numbers_amount_date_cur' }),

    flightNumbers: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'get_flight_numbers_amount_date_cur' }),

    // Engagement
    usersByDate: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'unique_users_date_cur' }),

    featuresUsage: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'feature_distribution_cur' }),

    featuresUsageAutoplay: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'feature_distribution_autoplay_cur' }),

    featuresUsageNotAutoplay: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'feature_distribution_not_autoplay_cur' }),

    videoAmount: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'video_data_cur' });

      return metric.map(
        (el) => ({ label: el.label, value: el.value_number }),
      );
    },

    videoDuration: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'video_data_cur' });

      return metric.map(
        // eslint-disable-next-line max-len
        (el) => ({ label: el.label, value: el.value_duration }),
      );
    },

    maxValueVideoDuration: (state, getters) => getters.videoDuration.reduce(
      (accum, cur) => (cur.value > accum ? cur.value : accum),
      0,
    ),

    videoDurationUnits: (state, getters) => {
      if (getters.maxValueVideoDuration <= 100 * 60) {
        return 'min:sec';
      }

      return 'h:min';
    },

    imagesAmount: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'images_data_cur' });

      return metric.map(
        (el) => ({ label: el.label, value: el.value_number }),
      );
    },

    imagesDuration: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'images_data_cur' });

      return metric.map(
        // eslint-disable-next-line max-len
        (el) => ({ label: el.label, value: el.value_duration }),
      );
    },

    maxValueImagesDuration: (state, getters) => getters.imagesDuration.reduce(
      (accum, cur) => (cur.value > accum ? cur.value : accum),
      0,
    ),

    imagesDurationUnits: (state, getters) => {
      if (getters.maxValueImagesDuration <= 100 * 60) {
        return 'min:sec';
      }

      return 'h:min';
    },

    riddlesAmount: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'riddles_data_cur' });

      return metric.map(
        (el) => ({ label: el.label, value: el.value_number }),
      );
    },

    riddlesDuration: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'riddles_data_cur' });

      return metric.map(
        (el) => ({ label: el.label, value: el.value_duration }),
      );
    },

    maxValueRiddlesDuration: (state, getters) => getters.riddlesDuration.reduce(
      (accum, cur) => (cur.value > accum ? cur.value : accum),
      0,
    ),

    riddlesDurationUnits: (state, getters) => {
      if (getters.maxValueRiddlesDuration <= 100 * 60) {
        return 'min:sec';
      }

      return 'h:min';
    },

    // destinations
    ratingsProgressDataDestinations: (state, getters) => {
      const destinations = getters.getMetricDataArrayByKey({ metricKey: 'destination_rating_cur' });
      const poiDestinations = getters.ratingsDataPoiFull;

      const allPois = [];

      const ratingsDataDestinations = [];

      const addPoiMergedByLabel = (pois, poiItem) => {
        const sameLabelPoi = pois.find((el) => el.label === poiItem.label);

        if (sameLabelPoi === undefined) {
          pois.push({
            ...poiItem,
            values: { ...poiItem.values },
            links: { videos: [...(poiItem.links.videos ?? [])] },
          });

          return;
        }

        sameLabelPoi.value += poiItem.value;
        Object.keys(sameLabelPoi.values).forEach((key) => {
          sameLabelPoi.values[key] += poiItem.values[key];
        });
        sameLabelPoi.links.videos = sameLabelPoi.links.videos.concat(poiItem.links.videos ?? []);
      };

      poiDestinations.forEach((poiItem) => {
        const featuredPoi = {
          label: poiItem.name,
          id: poiItem.id,
          value: poiItem.value,
          values: poiItem.values,
          links: poiItem.links,
        };
        addPoiMergedByLabel(allPois, featuredPoi);

        if (poiItem.geotags) {
          poiItem.geotags.forEach((geotagItem) => {
            // eslint-disable-next-line max-len
            const geotagIndex = ratingsDataDestinations.findIndex((el) => el.label === geotagItem.name);

            if (geotagIndex === -1) {
              const destinationPois = [
                {
                  label: '<All>',
                  id: 0,
                  value: poiItem.value,
                  values: { ...poiItem.values },
                  links: {
                    videos: poiItem.links.videos,
                  },
                },
              ];
              addPoiMergedByLabel(destinationPois, featuredPoi);

              ratingsDataDestinations.push({
                label: geotagItem.name,
                id: geotagItem.id,
                ids: [geotagItem.id],
                value: poiItem.value,
                pois: destinationPois,
              });
            } else {
              const mergedDestination = ratingsDataDestinations[geotagIndex];

              if (!mergedDestination.ids.includes(geotagItem.id)) {
                mergedDestination.ids.push(geotagItem.id);
              }

              mergedDestination.value += poiItem.value;
              mergedDestination.pois[0].value += poiItem.value;
              Object.keys(mergedDestination.pois[0].values).forEach((key) => {
                mergedDestination.pois[0].values[key] += poiItem.values[key];
              });
              addPoiMergedByLabel(mergedDestination.pois, featuredPoi);
            }
          });
        }
      });

      // eslint-disable-next-line no-restricted-syntax
      for (const destinationItem of destinations) {
        const ratingsDataDestinationsIndex = ratingsDataDestinations
          .findIndex((el) => el.label === destinationItem.label);

        if (ratingsDataDestinationsIndex === -1) {
          ratingsDataDestinations.push({
            label: destinationItem.label,
            id: destinationItem.id,
            ids: [destinationItem.id],
            value: destinationItem.value,
            pois: [
              {
                label: '<All>',
                id: 0,
                value: 0,
                values: {
                  total: 0,
                  click: 0,
                  highlights: 0,
                  pins: 0,
                  board: 0,
                  view_info: 0,
                },
                links: {
                  videos: [],
                },
              }],
          });
        } else {
          const mergedDestination = ratingsDataDestinations[ratingsDataDestinationsIndex];

          if (!mergedDestination.ids.includes(destinationItem.id)) {
            mergedDestination.ids.push(destinationItem.id);
          }

          mergedDestination.value += destinationItem.value;
        }
      }

      const allPoisAmount = allPois
        .reduce((accum, cur) => accum + cur.value, 0);

      const allPoiValues = allPois
        .reduce((accum, cur) => ({
          total: accum.total + cur.values.total,
          click: accum.click + cur.values.click,
          highlights: accum.highlights + cur.values.highlights,
          pins: accum.pins + cur.values.pins,
          board: accum.board + cur.values.board,
          view_info: accum.view_info + cur.values.view_info,
        }), {
          total: 0,
          click: 0,
          highlights: 0,
          pins: 0,
          board: 0,
          view_info: 0,
        });

      const allGeotagsAmount = ratingsDataDestinations
        .reduce((accum, cur) => accum + cur.value, 0);

      ratingsDataDestinations.unshift({
        label: '<All>',
        id: 0,
        ids: [0],
        value: allGeotagsAmount,
        pois: [{
          label: '<All>',
          id: 0,
          value: allPoisAmount,
          values: allPoiValues,
          links: { videos: [] },
        }, ...allPois.sort((a, b) => b.value - a.value)],
      });

      ratingsDataDestinations.sort((a, b) => b.value - a.value);

      return ratingsDataDestinations;
    },

    ratingsProgressDataPois: (state, getters) => (getters.ratingsProgressDataDestinations[
      getters.activeDestinationNumber
    ]
      ? [...getters.ratingsProgressDataDestinations[
        getters.activeDestinationNumber
      ].pois]
      : []),

    unitedDestinationData: (state, getters) => {
      const popularPlaces = getters.ratingsProgressDataDestinations[
        getters.activeDestinationNumber
      ]
        ? [...getters.ratingsProgressDataDestinations[
          getters.activeDestinationNumber
        ].pois]
        : [];

      const advertisement = getters.ratingsDataAdvertisementDestinations[
        getters.activeDestinationNumber
      ]
        ? [...getters.ratingsDataAdvertisementDestinations[
          getters.activeDestinationNumber
        ].advertisements]
        : [];

      const microsites = getters.ratingsDataMicrositesFullDestinations[
        getters.activeDestinationNumber
      ]
        ? [...getters.ratingsDataMicrositesFullDestinations[
          getters.activeDestinationNumber
        ].microsites]
        : [];

      const playlists = getters.ratingsDataPlaylistsFullDestinations[
        getters.activeDestinationNumber
      ]
        ? [...getters.ratingsDataPlaylistsFullDestinations[
          getters.activeDestinationNumber
        ].playlists]
        : [];

      return {
        popular_places: popularPlaces,
        advertisement,
        microsites,
        playlists,
      };
    },

    // passengers
    ratingsProgressDataPassengersInterests: (state, getters) => {
      const metric = getters.interests;

      return Vue.$arrayManagement.normalizedDataArray(metric);
    },

    ratingsProgressDataPassengersLanguages: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'get_langs_cur' });

      return Vue.$arrayManagement.normalizedDataArray(metric);
    },

    ratingsDataRiddlesAverage: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({ metricKey: 'riddles_average_cur' });

      return Vue.$arrayManagement.normalizedDataArray(
        [...metric].sort((a, b) => b.value - a.value),
      );
    },

    ratingsProgressDataUserDevices: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'get_devices_cur' }),

    deviceNumberMobile: (state, getters) => {
      const deviceMetric = getters.ratingsProgressDataUserDevices;

      const typeNumber = {
        number: 0,
        total: 0,
      };

      deviceMetric.forEach(
        (item) => {
          if (state.devicesTypesMapping.mobile.includes(item.label)) {
            typeNumber.number += item.value;
          }

          typeNumber.total += item.value;
        },
      );

      return typeNumber.total
        ? ((typeNumber.number * 100) / typeNumber.total).toFixed(0)
        : 0;
    },

    deviceNumberTablet: (state, getters) => {
      const deviceMetric = getters.ratingsProgressDataUserDevices;

      const typeNumber = {
        number: 0,
        total: 0,
      };

      deviceMetric.forEach(
        (item) => {
          if (state.devicesTypesMapping.tablet.includes(item.label)) {
            typeNumber.number += item.value;
          }

          typeNumber.total += item.value;
        },
      );

      return typeNumber.total
        ? ((typeNumber.number * 100) / typeNumber.total).toFixed(0)
        : 0;
    },

    deviceNumberDesktop: (state, getters) => {
      const deviceMetric = getters.ratingsProgressDataUserDevices;

      const typeNumber = {
        number: 0,
        total: 0,
      };

      deviceMetric.forEach(
        (item) => {
          if (
            !state.devicesTypesMapping.mobile.includes(item.label)
              && !state.devicesTypesMapping.tablet.includes(item.label)
          ) {
            typeNumber.number += item.value;
          }

          typeNumber.total += item.value;
        },
      );

      return typeNumber.total
        ? ((typeNumber.number * 100) / typeNumber.total).toFixed(0)
        : 0;
    },

    ratingsProgressDataUserOperatingSystems: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'get_os_cur' }),

    ratingsProgressDataUserBrowsers: (state, getters) => getters.getMetricDataArrayByKey({ metricKey: 'get_browsers_cur' }),

    // routes
    dataRoutesParamsFilters: (state, getters) => getters.getMetricDataObjectByKey({ metricKey: 'get_route_filters_cur' }),

    ratingsProgressDataRouteParams: (state, getters) => {
      const metric = getters.dataRoutesParamsFilters;
      const parameters = metric.parameters === undefined || metric.parameters.length === 0
        ? []
        : metric.parameters;

      if (metric.routes === undefined || metric.routes.length === 0) {
        return [];
      }

      const fullRoutes = [];

      metric.routes.forEach((routeItem) => {
        if (fullRoutes[routeItem.label] === undefined) {
          fullRoutes[routeItem.label] = {
            label: routeItem.label,
            value: 0,
            values: {
              route_build: 0,
              list_to_map: 0,
              date_selected: 0,
              flights_viewed: 0,
              flight_details: 0,
              bookings: 0,
            },
          };

          fullRoutes[routeItem.label].values.route_build += routeItem.value;
          fullRoutes[routeItem.label].value += routeItem.value;

          if (parameters[routeItem.label] !== undefined) {
            Object.keys(parameters[routeItem.label]).forEach((paramKey) => {
              fullRoutes[routeItem.label].values[paramKey] += parameters[routeItem.label][paramKey];
              fullRoutes[routeItem.label].value += parameters[routeItem.label][paramKey];
            });
          }
        }
      });

      const fullRoutesArray = Object.values(fullRoutes);

      if (fullRoutesArray.findIndex((el) => el.label === '<All>') === -1) {
        const allRoutesNumber = fullRoutesArray
          .reduce((accum, cur) => accum + cur.value, 0);

        const allParametersValues = fullRoutesArray
          .reduce((accum, cur) => ({
            route_build: accum.route_build + cur.values.route_build,
            list_to_map: accum.list_to_map + cur.values.list_to_map,
            date_selected: accum.date_selected + cur.values.date_selected,
            flights_viewed: accum.flights_viewed + cur.values.flights_viewed,
            flight_details: accum.flight_details + cur.values.flight_details,
            bookings: accum.bookings + cur.values.bookings,
          }), {
            route_build: 0,
            list_to_map: 0,
            date_selected: 0,
            flights_viewed: 0,
            flight_details: 0,
            bookings: 0,
          });

        fullRoutesArray.unshift({
          label: '<All>',
          value: allRoutesNumber,
          values: allParametersValues,
        });
      }

      return fullRoutesArray.sort((a, b) => b.value - a.value);
    },

    ratingsProgressDataFilters: (state, getters) => {
      const metric = getters.dataRoutesParamsFilters;

      if (!metric || metric.filters === undefined || metric.filters.length === 0) {
        return [];
      }

      // eslint-disable-next-line max-len
      const activeRoute = getters.ratingsProgressDataRouteParams[getters.activeRouteNumber];

      if (!activeRoute) {
        return [];
      }

      const filterRoute = activeRoute.label;
      const routeFilters = metric.filters[filterRoute];

      if (!routeFilters) {
        return [];
      }

      return Array.isArray(routeFilters) ? routeFilters : Object.values(routeFilters);
    },

    // eslint-disable-next-line max-len
    activeRouteName: (state, getters) => (getters.ratingsProgressDataRouteParams[getters.activeRouteNumber]
      ? `Filters for route: ${getters.ratingsProgressDataRouteParams[getters.activeRouteNumber].label}`
      : 'Filters'),

    // eslint-disable-next-line max-len
    activeRouteFilterName: (state, getters) => (getters.ratingsProgressDataFilters[getters.activeFilterNumber]
      ? `Filter Value: ${getters.ratingsProgressDataFilters[getters.activeFilterNumber].label}`
      : 'Filter Value'),

    // eslint-disable-next-line max-len
    ratingsProgressDataSelections: (state, getters) => {
      const activeFilter = getters.ratingsProgressDataFilters[getters.activeFilterNumber];

      if (!activeFilter || activeFilter.values == null) {
        return [];
      }

      return Array.isArray(activeFilter.values)
        ? [...activeFilter.values]
        : Object.values(activeFilter.values);
    },

    // eslint-disable-next-line max-len
    airportRouteMapDataNumberOfAirports: (state, getters) => getters.getMetricSpecificDataValueByKey({
      metricKey: 'tripbits_routemap_cur',
      dataKey: 'airports_amount',
    }),

    // eslint-disable-next-line max-len
    airportRouteMapDataFlightsPerMonth: (state, getters) => getters.getMetricSpecificDataValueByKey({
      metricKey: 'tripbits_routemap_cur',
      dataKey: 'flights_per_month',
    }),

    airportTripbitsDataNumberOfGuides: (state, getters) => getters.getMetricSpecificDataValueByKey({
      metricKey: 'tripbits_routemap_cur',
      dataKey: 'geotags_total_amount',
    }),

    airportTripbitsDataNumberOfPoi: (state, getters) => getters.getMetricSpecificDataValueByKey({
      metricKey: 'tripbits_routemap_cur',
      dataKey: 'pois_amount',
    }),

    airportTripbitsDataNumberOfReels: (state, getters) => getters.getMetricSpecificDataValueByKey({
      metricKey: 'tripbits_routemap_cur',
      dataKey: 'videos_amount',
    }),

    routeDestinationsFilter: (state, getters) => {
      const metric = getters.getMetricDataArrayByKey({
        metricKey: 'route_destinations_cur',
        metricsArray: getters.routeDestinations,
      });

      return [{ caption: 'empty', id: null }, ...metric.map((el) => ({ caption: el.label, id: el.label }))];
    },

    // metrics end
  },

  mutations: {
    SET_AIRPORT_APP_URL(state, value) {
      state.airportAppUrl = value;
    },

    SET_IS_COMPOSITE_CUSTOMER_HAS_AIRPORT(state, value) {
      state.isCompositeCustomerHasAirport = value;
    },

    CLEAR_METRICS_DATA(state) {
      state.metricsData = {};
    },

    SET_METRICS_DATA(state, metricsData) {
      state.metricsData = metricsData;
    },

    ADD_METRICS_DATA(state, metricsData) {
      state.metricsData = { ...state.metricsData, ...metricsData };
    },

    SET_STATIC_METRICS_DATA(state, metricsData) {
      state.staticMetricsData = metricsData;
    },

    SET_IS_USE_STATIC_METRICS_DATA(state, value) {
      state.isUseStaticMetricData = value;
    },

    SET_METRIC_DATA(state, { metricKey, metricData }) {
      state.metricsData[metricKey] = metricData;
    },

    SET_ACTIVE_DESTINATION(state, destinationNumber) {
      state.activePagedItemNumber.destination = destinationNumber;
    },

    SET_ACTIVE_ROUTE(state, routeNumber) {
      state.activePagedItemNumber.route = routeNumber;
    },

    SET_ACTIVE_FILTER(state, filterNumber) {
      state.activePagedItemNumber.filter = filterNumber;
    },

    SET_ROUTE_DESTINATIONS(state, routeDestinations) {
      state.routeDestinations = routeDestinations;
    },
  },

  actions: {
    setAirportAppUrl({ commit }, value) {
      commit('SET_AIRPORT_APP_URL', value);
    },

    setIsCompositeCustomerHasAirport({ commit }, value) {
      commit('SET_IS_COMPOSITE_CUSTOMER_HAS_AIRPORT', value);
    },

    clearMetricsData({ commit }) {
      commit('CLEAR_METRICS_DATA');
    },

    setMetricData({ commit }, { metricKey, metricData }) {
      commit('SET_METRIC_DATA', { metricKey, metricData });
    },

    setMetricsData({ commit }, metricsData) {
      commit('SET_METRICS_DATA', metricsData);
    },

    addMetricData({ commit }, { metricKey, metricData }) {
      commit('ADD_METRIC_DATA', { metricKey, metricData });
    },

    addMetricsData({ commit }, metricsData) {
      commit('ADD_METRICS_DATA', metricsData);
    },

    setStaticMetricsData({ commit }, metricsData) {
      commit('SET_STATIC_METRICS_DATA', metricsData);
    },

    setIsUseStaticMetricsData({ commit }, value) {
      commit('SET_IS_USE_STATIC_METRICS_DATA', value);
    },

    setActiveDestination({ commit }, destinationNumber) {
      commit('SET_ACTIVE_DESTINATION', destinationNumber);
    },

    setActiveRoute({ commit }, routeNumber) {
      commit('SET_ACTIVE_ROUTE', routeNumber);
    },

    setActiveFilter({ commit }, filterNumber) {
      commit('SET_ACTIVE_FILTER', filterNumber);
    },

    setRouteDestinations({ commit }, routeDestinations) {
      commit('SET_ROUTE_DESTINATIONS', routeDestinations);
    },
  },
};
